import { ManualAccountCategoryActions } from "@dots-crm/contracts/client";

export const MANUAL_CATEGORY_ENDPOINTS_URLS = {
  create: "manual-account-category",
  readMany: "manual-account-category",
  readAvailable: "manual-account-category/available",
  readOne: ({ categoryId }: ManualAccountCategoryActions["readOne"]["params"]) =>
    `manual-account-category/${categoryId}`,
  update: ({ categoryId }: ManualAccountCategoryActions["update"]["params"]) =>
    `manual-account-category/${categoryId}`,
  delete: ({ categoryId }: ManualAccountCategoryActions["delete"]["params"]) =>
    `manual-account-category/${categoryId}`,
};

export const MANUAL_CATEGORY_TAGS = {
  manualCategory: "manualCategory",
};
